import React from 'react';

const OFFSET = 80; // ヘッダーの高さなど、上に余白を作りたい場合のピクセル数

function scrollToId(id) {
  const target = document.getElementById(id);
  if (target) {
    const y = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

function TableOfContents() {
  return (
    <nav className="mb-14 flex flex-wrap justify-center gap-4 animate-fade-in-up">
      <button
        type="message"
        onClick={() => scrollToId('message')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        メッセージ
      </button>
      <button
        type="button"
        onClick={() => scrollToId('philosophy')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        シャルンについて
      </button>
      <button
        type="button"
        onClick={() => scrollToId('performance')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        事業内容
      </button>
      <button
        type="button"
        onClick={() => scrollToId('company')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        会社概要
      </button>
      <button
        type="button"
        onClick={() => scrollToId('news')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        お知らせ
      </button>
      <button
        type="button"
        onClick={() => scrollToId('recruit')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        採用情報
      </button>
      <button
        type="button"
        onClick={() => scrollToId('contact')}
        className="px-6 py-2 rounded-full bg-gradient-to-r from-cyan-500/30 via-blue-500/30 to-purple-500/30 hover:from-cyan-400/60 hover:to-purple-400/60 transition font-semibold text-sm md:text-base shadow-lg border border-cyan-300/20 hover:border-cyan-300/60 backdrop-blur-md"
      >
        お問い合わせ
      </button>
    </nav>
  );
}

export default TableOfContents;